import React, {Component} from 'react';
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import LegalNoticeFr from "./LegalNoticeFr";
import LegalNoticeNl from "./LegalNoticeNl";
import LegalNoticeDe from "./LegalNoticeDe";
import {Card, Col, Row} from "antd";
import "./LegalNotice.css"

class LegalNotice extends Component {

  render() {
    return (
      <Row gutter={32} type={"flex"} className={"data-privacy"}>
        <Col>
          <Card>
            <LegalNoticeFr/>
            <LegalNoticeNl/>
            <LegalNoticeDe/>
          </Card>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(injectIntl(LegalNotice));
